import { FC } from 'react';

import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { Footer } from './Footer';
import { Header } from './Header';

export type ReportProps = {
  id: number;
  createdAt: string;
  finishedAt: string;
  workerFIO: string;
  cash: number;
  card: number;
  inCashBox: number;
  bonus: number;
  deposit: number;
  onlineDeposit: number;
  cashOnStart: number;
  currency: string;
  clubName: string;
  isDuplicate: boolean;
  t: TTranslator<TLocalesKeys>;
};

export const WorkShiftReport: FC<ReportProps> = (props) => (
  <>
    <Header {...props} />
    <Footer {...props} />
  </>
);
